import { specialCaseFormats } from '../consts';
// This method assumes that the base image is a jpg, which won't work for images with transparency. This is because, for transparent images, we should not use the base image
const calcBasePath = (uuid: string, extension: string) => {
  const ext = specialCaseFormats.includes(extension.toLowerCase()) ? 'webp' : 'jpg';
  return `${uuid}/base/${uuid}.${ext}`;
};

export const calcBaseUrl = (imagesEndpoint: string, uuid: string, extension: string) => {
  return `${imagesEndpoint}/images/${calcBasePath(uuid, extension)}`;
};

export const calcBaseUrlPdf = (imagesEndpoint: string, key: string) => {
  return `${imagesEndpoint}/assets/${key}`;
};
